import { AddressFallbackRecord, AddressRecord } from '@navio/nsdk';

export const getShortAddressName = (address: { streetName: string; streetNumber: string }) =>
  `${address.streetName} ${address.streetNumber}`;

export const getMediumAddressName = (address: AddressRecord) =>
  `${address.streetName} ${address.streetNumber}, ${address.city}`;

export const getLongAddressName = (
  address: Pick<AddressRecord, 'streetName' | 'streetNumber' | 'zipCode' | 'city'>
) => {
  return `${address.streetName} ${address.streetNumber}, ${address.zipCode} ${address.city}`;
};

export const addressRecordToFallback = (
  address: Pick<AddressRecord, 'streetName' | 'streetNumber' | 'zipCode' | 'city'>
): AddressFallbackRecord => ({
  address: getShortAddressName(address).trim(),
  zipcode: address.zipCode,
  city: address.city
});
